export default __webpack_public_path__ + "static/media/home_10.b6b8ae7a.svg";